module.exports = __webpack_public_path__ + "assets/2a8d46f1ad94b07ce7ab6e9021050dbe.png";